import { locationIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const confirmSkuCount = {
  name: "confirmSkuCount" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
    quantity: z.number().int().nonnegative(),
  }),
  output: z.object({ success: z.boolean(), delta: z.number() }),
};
